import { styled } from '@mui/material/styles';
import { Drawer, AppBar, Toolbar, IconButton, Box, Avatar } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
    FielderPink, AliceBlue,
    CottonCandyLight, FielderHard,
    White, DeepSpaceGreyDark
} from '@core/theme/baseTheme';
export const TopMenuNotifyIconButtonStyled = styled(IconButton)({
    '&:hover': {
      padding: '0px',
      margin: '8px',
    },
});
export const NotifyDrawerStyled = styled(Drawer)({
    '& .MuiDrawer-paper': {
        width: '30%',
        maxWidth: '460px',
        '@media (min-width:900px)': {
            width: '40%',
        },
        '@media (min-width:1450px)': {
            width: '460px',
        },
    },
});
export const NotifyDrawerAppBarStyled = styled(AppBar)(({ theme }) => ({
    fontFamily: 'Lato, sans-serif !important',
    backgroundColor: theme.palette.background.paper,
    color: DeepSpaceGreyDark
}));
export const NotifyDrawerToolbarStyled = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.paper,
}));
export const NotifyDrawerIconButtonStyled = styled(IconButton)({
    color: DeepSpaceGreyDark
});
export const NotifyDrawerBoxStyled = styled(Box)({
    width: '100%',
    bgColor: 'background.paper',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
});
export const NotifyDrawerBoxLoadingStyled = styled(Box)({
    justifyContent: 'center',
    alignItems: 'center',
});
export const NotifyContainerGridStyled = styled(Grid)({
    height: '90vh',
    boxShadow: '0 2px 28px 0 rgba(195, 193, 193, 0.5)',
    backgroundColor: White,
    position: 'relative',
    overflowY: 'auto',
});
export const NotifyContainerEmptyBoxStyled = styled(Grid)({
    fontFamily: 'Lato, sans-serif !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60vw',
    width: '100%'
});
export const NotifyContainerTypoSubTitleStyled = styled(Grid)({
    padding: '10px',
    fontWeight: 'bold',
});
export const StatusIconAvatar = styled(Avatar)(({ theme }) => ({
    border: `1px solid ${theme.palette.background.paper}`,
}));
export const ProfileAvatar = styled(Avatar)(({ theme }) => ({
    border: `0px solid ${FielderHard}`,
}));
export const NotifyItemRootBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'read',
})(({ read }) => ({
  cursor: 'pointer',
  alignItems: 'center',
  margin: '7px',
  padding: '12px',
  fontFamily: 'Lato, sans-serif !important',
  transition: 'all 0.3s ease-in-out',
  borderBottom: '#ECEFEF 1px solid',
  borderRadius: read === 0 ? 9 : 0,
  backgroundColor: read === 0 ? AliceBlue : undefined,
  '&:hover': {
    borderRadius: 9,
    borderColor: CottonCandyLight,
    backgroundColor: CottonCandyLight,
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.1)',
  },
}));

export const SkeletonBox = styled(Box)({
  width: '100%',
  borderRadius: 8,
  alignItems: 'center',
  margin: '4px',
  padding: '4px',
  fontFamily: 'Lato, sans-serif !important',
  borderColor: CottonCandyLight,
  boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.1)',
});

export const SkeletonAvatar = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '30px !important',
});

export const SkeletonTitle = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const SkeletonDescription = styled(Box)({
  marginTop: '10px',
});

export const SkeletonFooter = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '10px',
});

export const TitleBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  color: DeepSpaceGreyDark,
});

export const TitleFolio = styled(Box)({
  color: DeepSpaceGreyDark,
});

export const TitleId = styled(Box)({
  fontWeight: 'bold',
  color: DeepSpaceGreyDark,
});

export const DescriptionName = styled(Box)({
  color: FielderPink,
  fontWeight: 'bold',
});

export const DescriptionTask = styled(Box)({
  color: DeepSpaceGreyDark,
  fontWeight: 'bold',
});

export const FooterBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '52px',
});

export const SettingIconsBox = styled(Box)({
  display: 'none',
  height: '100%',
});
